export default "__VITE_ASSET__CdS3o0nK__"